export const Colors = {
  main1: "#13c892",
  main2: "#ea5681",
  main3: "#ffc14a",
  error: "#eb5757",
  black: "#0F3E4A",
  white: "#FFFFFF",
};
